import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
// ✅ Mock zaloJSV2 nếu chưa được inject bởi Webview
if (typeof window.zaloJSV2 === 'undefined') {
  window.zaloJSV2 = {
    zalo_h5_event_handler: function (eventId, eventName, eventData) {}
  };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
